var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33454 14.3094H11.1455C12.4258 14.3094 13.5554 13.2551 13.5554 11.8996V2.33551C13.5554 1.05528 12.5011 0.000976562 11.2208 0.000976562H2.33454C1.05431 0.000976562 0 1.05528 0 2.33551V11.8996C0 13.2551 1.05431 14.3094 2.33454 14.3094ZM4.36785 4.44413H9.18754C9.63938 4.44413 9.94062 4.82067 9.94062 5.19721C9.94062 5.64905 9.63938 5.95028 9.18754 5.95028H4.36785C3.916 5.95028 3.61477 5.64905 3.61477 5.19721C3.61477 4.74536 3.916 4.44413 4.36785 4.44413ZM4.36785 8.36013H9.18754C9.63938 8.36013 9.94062 8.66136 9.94062 9.11321C9.94062 9.48975 9.63938 9.86628 9.18754 9.86628H4.36785C3.916 9.86628 3.61477 9.48975 3.61477 9.11321C3.61477 8.73667 3.916 8.36013 4.36785 8.36013Z",
    fill: "#4F6E90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7423 3.7666H15.0646V11.9751C15.0646 14.1591 13.3325 15.8911 11.1486 15.8911H4.52148C4.59679 17.1714 5.6511 18.1504 6.93133 18.1504H15.7423C17.0226 18.1504 18.1522 17.0961 18.1522 15.7405V6.10114C18.0769 4.82091 17.0226 3.7666 15.7423 3.7666Z",
    fill: "#4F6E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.67bc0266eae9948d59ce73b9a3b327f6.svg";
export { ForwardRef as ReactComponent };